import React, { useEffect, useState, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Fire from "../../../api/Fire";
import { useTranslation } from "react-i18next";
import Dialog from "../../../components/Dialog";
import ShareDialog from "../../../components/ShareDialog";
import CartContext from "../../../contexts/cart";
import DataContext from "../../../contexts/data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareAlt } from "@fortawesome/free-solid-svg-icons";
import Product from "../../../components/Product";

const Index = (props) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { cart } = useContext(CartContext);
  const { baskets } = useContext(DataContext);
  const [quantity, setQuantity] = useState(1);
  const [basket, setBasket] = useState({});
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [shareVisible, setShareVisible] = useState(false);
  const [type, setType] = useState(1);

  useEffect(() => {
    const getData = async () => {
      try {
        const b = await Fire._getBasket(id);
        window.document.title = t("language") === "en" ? b.name : b.nameEn;
        setBasket(b);
      } catch (error) {
        setMessage(error.message);
        setType(2);
        setVisible(true);
      } finally {
        setLoading((prev) => false);
      }
    };

    getData(id);
  }, [id]);

  const _addToCart = async () => {
    let list = [...cart];
    let i = { id: basket.id, quantity: quantity, type: "basket" };

    if (list.some((obj) => obj.id === basket.id)) {
      let objIndex = list.findIndex((obj) => obj.id === basket.id);
      list[objIndex] = i;
    } else {
      list = [...list, i];
    }
    await Fire._updateCart({ items: list });
  };

  const _renderOptions = () => {
    let arr = [...Array(basket.quantity)];

    return (
      <div className="d-flex justify-content-end align-items-center my-3">
        <select
          className="form-select bg-light border-0"
          onChange={(event) => setQuantity(parseFloat(event.target.value))}
          value={quantity}
        >
          {arr.map((x, i) => {
            return (
              <option key={i} value={i + 1}>
                {i + 1}
              </option>
            );
          })}
        </select>
        <button className="btn btn-success py-1 mx-1" onClick={_addToCart}>
          {t("addToCart")}
        </button>
      </div>
    );
  };

  return (
    <main>
      {loading ? (
        <Row>
          <Col lg={12} className="mt-5 d-flex align-items-center justify-content-center">
            <div className="spinner-grow text-success mt-5" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </Col>
        </Row>
      ) : (
        <Row className={`mt-5 text-center ${t("language") === "en" ? "text-lg-end" : "text-lg-start"}`}>
          <Col lg={5} className="border-start text-center">
            <img src={basket.thumbnail} alt={basket.nameEn} height={250} width={250} className="rounded" />
          </Col>
          <Col lg={7} className="px-3 d-flex flex-column-reverse flex-lg-row">
            <div className="flex-fill">
              <div className="mt-4 mt-lg-0">
                <strong className="h2">{t("language") === "en" ? basket.name : basket.nameEn}</strong>
              </div>

              {/* Sale Badge */}
              {basket.sale && new Date() < new Date(basket.saleEnd) ? (
                <div className="d-flex my-3 justify-content-center justify-content-lg-start">
                  <div className="rounded px-2 text-light bg-danger">{basket.sale} %</div>
                </div>
              ) : null}
              {/* Sale Badge */}

              {basket.sale && new Date() < new Date(basket.saleEnd) ? (
                <div className="my-3">
                  <del className="mx-3">{basket.price}</del>
                  <span className="text-danger">{basket.price - basket.price * (basket.sale / 100)} </span>
                  <span className="text-muted mx-1" style={{ fontSize: 12 }}>
                    {t("SAR")}
                  </span>
                  <span className="text-muted mx-1" style={{ fontSize: 12 }}>
                    {t("vat")}
                  </span>
                </div>
              ) : (
                <div className="my-4">
                  <span className="h4">
                    <b>{basket.price}</b>
                  </span>
                  <span className="text-muted mx-1" style={{ fontSize: 12 }}>
                    {t("SAR")}
                  </span>
                  <span className="text-muted mx-1" style={{ fontSize: 12 }}>
                    {t("vat")}
                  </span>
                </div>
              )}

              {_renderOptions()}
            </div>

            {/* Share Option */}
            <div className="mt-3">
              <FontAwesomeIcon
                icon={faShareAlt}
                size="lg"
                color="black"
                className="hoverable"
                onClick={() => setShareVisible(true)}
              />
            </div>
            {/* Share Option */}
          </Col>

          <Col lg={12}>
            <hr className="text-muted" />

            <h5 className="text-center">
              <strong>{t("details")}</strong>
            </h5>

            <div className="mt-4">
              {basket.description.split("\n").map((l, i) => (
                <p key={i}>{l}</p>
              ))}
            </div>
          </Col>

          {/* More baskets */}
          <Col lg={12}>
            <hr className="text-muted" />

            <h5 className="text-center">
              <strong>{t("morebaskets")}</strong>
            </h5>

            <div className="more-items">
              {baskets
                .filter((p) => p.category === basket.category && p.id !== basket.id)
                .map((p, i) => (
                  <div className="mx-2" key={1}>
                    <Product item={p} onClick={() => props.history.push({ pathname: `/baskets/details/${p.id}` })} />
                  </div>
                ))}
            </div>
          </Col>
          {/* More Products */}
        </Row>
      )}

      <Dialog visible={visible} onHide={() => setVisible(false)} message={message} type={type} />
      <ShareDialog visible={shareVisible} onHide={() => setShareVisible(false)} url={window.location.href} />
    </main>
  );
};

export default Index;
